import React from 'react';
import {Field, reduxForm} from 'redux-form';
import label from '../../utils/lngEn';
import {Modal} from 'react-bootstrap';
import Multiselect from 'react-widgets/lib/Multiselect';


const renderMultiselect = ({ input, meta: {touched, error}, ...rest }) => {
  console.log('----------', rest)
  return (
  <div>
    <Multiselect {...input}
                 onBlur={() => input.onBlur()}
                 value={input.value || []} // requires value to be an array
                 {...rest}/>
    <div>
      {touched && (error && <span className="text-danger">{error}</span>)}
    </div>
  </div>
)
  }

const validate = values => {
  const errors = {};

  if (!values.students || values.students.length == 0) {
    errors.students = 'Required'
  }
  return errors;
}

const AddStudentsForm = (props) => {
  const {handleSubmit, submitting, onCancel, studentsArray, description} = props;
  return (
    <form onSubmit={handleSubmit} className="overflow-visible mt-4">
      <label htmlFor="groups">Students</label>
      <Field
        name="students"
        component={renderMultiselect}
        textField="email"
        valueField="id"
        data={studentsArray}/>
      <span className="input-description">{description || 'Select the Student(s) to put into Group.'}</span>
      <Modal.Footer className="mt-4">
        <button type="button" onClick={onCancel} className="btn  btn-ter pull-left">Cancel</button>
        <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>Save</button>
      </Modal.Footer>
    </form>
  )
}

export default reduxForm({
  form: 'AddStudentsForm',
  validate
})(AddStudentsForm);



// WEBPACK FOOTER //
// ./src/components/groups/AddStudentsForm.js